import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import SurveyorModel from "../models/SurveyorModel";
import SurveyorQueryModel from "../models/SurveyorQueryModel";

export interface SearchSurveyorParam {
    pageSize: number,
    query: SurveyorQueryModel
}

export interface GetSurveyorByIdParam {
    id: string,
}

export interface GetSurveyorByIdsParam {
    ids: string[],
}

export interface DeleteSurveyorByIdParam {
    id: string,
}
export interface SearchSurveyorNameParam {
    keyword: string,
}

const SurveyorApi = {
    GetAll() {
        return Api.get<unknown, BaseResponse<SurveyorModel[]>>("/api/Surveyor/GetAll", null);
    },
    Search(param: SearchSurveyorParam) {
        return Api.post<SearchSurveyorParam, BaseResponse<SurveyorModel[]>>("/api/Surveyor/Search", param);
    },
    Save(param: SurveyorModel) {
        return Api.post<SurveyorModel, BaseResponse<SurveyorModel>>("/api/Surveyor/Save", param);
    },
    GetById(param: GetSurveyorByIdParam) {
        return Api.get<GetSurveyorByIdParam, BaseResponse<SurveyorModel>>("/api/Surveyor/GetById", param);
    },
    GetByIds(param: GetSurveyorByIdsParam) {
        return Api.get<GetSurveyorByIdsParam, BaseResponse<SurveyorModel[]>>("/api/Surveyor/GetByIds", param);
    },
    Delete(param: DeleteSurveyorByIdParam) {
        return Api.post<DeleteSurveyorByIdParam, BaseResponse<SurveyorModel>>("/api/Surveyor/Delete", param);
    },
};
export default SurveyorApi;